export const PROJECT_SELECTION_ROUTES = {
  BASE_URL: 'ProjectSelection',
	MY_PROJECT_SELECTIONS: 'MyProjectSelections'
};

export const PRODUCT_ROUTES = {
  BASE_URL: 'Product',
  FAMILY: 'Family',
  UPDATE_STATE_PRODUCT_TO_PUBLISH: 'Publish',
  UPDATE_STATE_PRODUCT_TO_UNPUBLISH: 'Unpublish',
  SEARCH_PRODUCT: 'SearchProducts'
}

export const FAMILIES_ROUTES = {
  BASE_URL: 'Families',
  NAMES: 'Names',
  ALL: 'All'
};

export const ASSETS_ROUTES = {
  BASE_URL: 'Assets',
  CONTROLLER_NAME: {
    CREATE_FILE: 'CreateFile',
    GET_ASSETS_BY_TYPE: 'GetAssetsByType',
  }
}

export const FAMILY_PREVIEW_ROUTS = {
  BASE_URL: 'FamilyPreview'
}

export const ASSETS_MWC_ROUTES = {
  BASE_URL: 'AssetsMwc',
};

export const PAGE_ROUTES = {
  BASE_URL: 'Page',
  PUBLISH: 'Publish',
  UNPUBLISH: 'Unpublish'
};

export const SECTIONS = [
  {
    name: "Antenna System",
		imageFileName:"Front_Antenna.jpg",
    prefix: "antenna-system/"
  },
  {
    name: "Mobile Transport",
		imageFileName:"Front_Mobile_Transport.jpg",
    prefix: "mobile-transport/"
  },
  {
    name: "RAN Compute",
		imageFileName:"Front_RAN_Compute.jpg",
    prefix: "ran-compute/"
  },
  {
    name: "Massive MIMO",
		imageFileName:"Front_Massive_MIMO.jpg",
    prefix: "massive-mimo/"
  },
  {
    name: "Remote Radio",
		imageFileName:"Front_Remote_Radio.jpg",
    prefix: "remote-radio/"
  },
  {
    name: "Street & Outdoor",
		imageFileName:"Front_Street.jpg",
    prefix: "street-outdoor/"
  },
  {
    name: "Indoor",
		imageFileName:"Front_Indoor.jpg",
    prefix: "indoor/"
  },
  {
    name: "Site System",
		imageFileName:"Front_Site.jpg",
    prefix: "site-system/"
  },
  {
    name: "RAN Connect",
		imageFileName:"Front_RAN_Connect.jpg",
    prefix: "ran-connect/"
  }
];

export const PRODUCT_FAMILIES = {
  'antenna-system/': ['ERS_Family_Antenna.svg'],
  'mobile-transport/': ['ERS_Family_Transport_1.svg', 'ERS_Family_Transport_2.svg', 'ERS_Family_Transport_3.svg'],
  'ran-compute/': ['ERS_Family_RAN_Compute.svg'],
  'massive-mimo/': ['ERS_Family_Massive_MIMO.svg'],
  'remote-radio/': ['ERS_Family_Remote_Radio.svg'],
  'street-outdoor/': ['ERS_Family_Street.svg'],
  'indoor/': ['ERS_Family_Indoor.svg'],
  'site-system/': ['ERS_Family_Site_1.svg', 'ERS_Family_Site_2.svg', 'ERS_Family_Site_3.svg']
};

export const PRODUCT_FAMILIES_MANA = {
  'antenna-system/': ['ERS_Family_Antenna_MANA.svg'],
  'mobile-transport/': ['ERS_Family_Transport_1.svg', 'ERS_Family_Transport_2.svg', 'ERS_Family_Transport_3.svg'],
  'ran-compute/': ['ERS_Family_RAN_Compute.svg'],
  'massive-mimo/': ['ERS_Family_Massive_MIMO.svg'],
  'remote-radio/': ['ERS_Family_Remote_Radio.svg'],
  'street-outdoor/': ['ERS_Family_Street.svg'],
  'indoor/': ['ERS_Family_Indoor.svg'],
  'site-system/': ['ERS_Family_Site_1.svg', 'ERS_Family_Site_2.svg', 'ERS_Family_Site_3.svg']
};

export const GENERAL = {
  prefix: "/",
  callback: "callback",
  silentRenew: "silent-renew",
  productFamilyFileName: "productFamilyView.vue",
  singleProductFileName: "singleProductView.vue",
  productFamilyTree:{
      name: "Ericsson Radio System Portfolio",
      fileName: "productFamilyTreeView.vue",
      prefix: "productFamilyTreeView/",
      treeImageFileName: "ERS_TREE.png"
  }
}

export const USER_GUIDE = {
  link: "https://ericsson.sharepoint.com/:w:/r/sites/EVPET21V21Assignment/Shared%20Documents/General/Demo%20-%20ERS/Tech%20documents/Admin%20panel%20user%20guide.docx?d=w98688128aaed4534b07c61cc6bdfa082&csf=1&web=1&e=xizXid"
}